const setBgAction = (payload) => {
  console.log("BG changed");
  return {
    type: "bgChange",
    payload
  }
}
export default setBgAction;